import type { IRecordListParams } from '@platform/core/types';

/** Перша сторінка типу за номером (records[0] прототипу — запис із найменшим номером). */
const FIRST_PAGE: IRecordListParams = { page: 1, pageSize: 10, sort: 'code' };

/**
 * Аргументи читання першого запису типу для «Відкрити запис» шапки редактора форми — ті самі для шапки (SettingsFormHead) і для читання
 * наперед (useCustomizeReads), тож обидва читають один запис кешу. Чиста функція.
 */
export function firstRecordArgs(ws: string, rt: string) {
  return { ws, rt, params: FIRST_PAGE };
}
